module.exports = {"legal_headline":"Privacy Policy"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/default/setting/legal/locale.json
// module id = 496
// module chunks = 0 1 2 3 4 5